module.exports = __webpack_public_path__ + "img/4bakancstabla.650d9990.jpg";